import type { HelpTagDefinition } from '~/types/help'
import tagsJson from '~/content/help/tags.json'

const TAGS = tagsJson as HelpTagDefinition[]

const byName = new Map(TAGS.map((tag) => [tag.name.toLowerCase(), tag]))
const bySlug = new Map(TAGS.map((tag) => [tag.slug, tag]))

export function getHelpTags(): HelpTagDefinition[] {
  return TAGS
}

export function getHelpTagBySlug(slug: string): HelpTagDefinition | undefined {
  return bySlug.get(slug)
}

export function getHelpTagByName(name: string): HelpTagDefinition | undefined {
  return byName.get(name.toLowerCase())
}

export function helpTagHref(name: string): string {
  const tag = getHelpTagByName(name)
  if (tag) {
    return tag.url
  }

  return `/help/tag/${slugifyHelpTag(name)}/`
}

export function slugifyHelpTag(name: string): string {
  const map: Record<string, string> = {
    а: 'a', б: 'b', в: 'v', г: 'g', д: 'd', е: 'e', ё: 'e', ж: 'zh', з: 'z',
    и: 'i', й: 'y', к: 'k', л: 'l', м: 'm', н: 'n', о: 'o', п: 'p', р: 'r',
    с: 's', т: 't', у: 'u', ф: 'f', х: 'h', ц: 'c', ч: 'ch', ш: 'sh', щ: 'sch',
    ъ: '', ы: 'y', ь: '', э: 'e', ю: 'yu', я: 'ya',
  }

  return name
    .toLowerCase()
    .split('')
    .map((char) => map[char] ?? char)
    .join('')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}
